import {DownloadOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons';
import {Breadcrumb, Button, Col, Divider,  Row, Table, Tooltip} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import { fetchInquiryQuotationById} from '../../../slices/inquiry-quotation';
import PrintQuotation from '../../Authentication/PrintQuotation';
import html2pdf from 'html2pdf.js';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const ViewInquiryQuotation = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [quotationData, setQuotationData] = useState(null);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const { user: currentUser } = useSelector(state => state.auth);
  let navigate = useNavigate();
  const printRef = useRef();

  const handleDownloadPDF = () => {
    const element = printRef.current;
    if (!element) return;

    setLoadingPDF(true);
    const clone = element.cloneNode(true);
    clone.querySelectorAll('.no-print').forEach(el => el.remove());
    const logo = clone.querySelector('img.company-logo');
    if (logo) {
      const logoWrapper = document.createElement('div');
      logoWrapper.style.backgroundColor = 'white';
      logoWrapper.style.display = 'inline-block';
      logoWrapper.style.padding = '6px';
      logoWrapper.style.borderRadius = '4px';
      logoWrapper.style.textAlign = 'center';

      logo.parentNode.insertBefore(logoWrapper, logo);
      logoWrapper.appendChild(logo);
    }
    const imageElements = Array.from(clone.querySelectorAll('img')).filter(img => {
      const src = img.getAttribute('src') || '';
      return !img.classList.contains('company-logo') && !src.includes('logo.png');
    });

    const style = document.createElement('style');
   

    style.innerHTML = `
    * {
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #000000 !important;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji !important;
      }
      @page {
        size: A4 portrait;
        margin: 10mm !important;
      }
      body {
        font-size: 9px !important;
        margin: 0 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
      .print-container-quotation {
        width: 794px !important;
        min-height: 1000px !important;
        position: relative !important;
        padding-bottom: 100px !important;
        margin: 0 auto !important;
      }
      .main-heading {
        font-size: 15px !important;
        text-align: center !important;
        width: 100% !important;
      }
      .page {
        page-break-after: always !important;
        position: relative !important;
        box-sizing: border-box !important;
        overflow: visible !important;
        width: 794px !important;
      }
      .header-text {
        font-size: 10px !important;
        line-height: 1.2 !important;
        text-align: left !important;
      }
      .page-content {
        width: 100% !important;
        overflow: visible !important;
        font-size: 10px !important;
      }
      .signature-section {
        position: absolute !important;
        bottom: 10px !important;
        width: 100% !important;
        text-align: center !important;
        margin-top: 0 !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
      .terms-and-bank-container {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        page-break-before: always !important;
        height: 100vh !important;
        display: flex !important;
        flex-direction: column !important;
        justify-content: space-between !important;
        width: 794px !important;
        margin: 0 auto !important;
      }
      .terms-content-wrapper {
        flex: 1 !important;
        overflow: hidden !important;
      }
      .bank-details-wrapper {
        margin-top: auto !important;
        padding-top: 20px !important;
      }
      .bankDetails {
        font-size: 11px !important;
        margin-left: 5px !important;
        line-height: 1.1 !important;
      }
      .ant-row {
        display: flex !important;
        flex-wrap: wrap !important;
        margin-bottom: 5px !important;
      }
      .ant-col {
        box-sizing: border-box !important;
        padding: 1px !important;
      }
      h1, h2, h3, h4, h5 {
        color: rgb(2, 15, 28) !important;
        font-size: 12px !important;
        margin-bottom: 3px !important;
        margin-top: 0 !important;
      }
      .ant-table {
        width: 794px !important;
        font-size: 9px !important;
        table-layout: fixed !important;
        margin: 5px 0 !important;
        border-collapse: collapse !important;
      }
      .ant-table-container {
        overflow: visible !important;
        border: 1px solid #dee2e6 !important;
        padding: 0px !important;
        width: 794px !important;
      }
      .ant-table-wrapper {
        padding: 0 !important;
        overflow: visible !important;
        width: 794px !important;
      }
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        padding: 2px 2px !important;
        font-size: 8px !important;
        background-color: white !important;
        border: 1px solid #dee2e6 !important;
        white-space: normal !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        word-break: break-word !important;
        line-height: 1.1 !important;
        height: auto !important;
        min-height: 18px !important;
      }
      .ant-table-thead > tr > th {
        background: #fff !important;
        padding: 2px !important;
        font-weight: bold !important;
      }
      .ant-table-wrapper .ant-table-summary > tr > td {
        border: 1px solid #dee2e6 !important;
        padding: 1px 1px !important;
        font-size: 8px !important;
      }
      .summary-cell-center {
        text-align: center !important;
      }
      .summary-cell-right {
        text-align: right !important;
        padding-right: 3px !important;
      }
      .ant-divider {
        margin: 5px 0 !important;
        border-top: 1px solid #d9d9d9 !important;
      }
      .no-print {
        display: none !important;
      }
      .terms-heading {
        font-size: 12px !important;
        margin-bottom: 4px !important;
        text-align: center !important;
      }
      .terms__content ul li {
        font-size: 8px !important;
      }
      .terms__content {
        font-size: 8px !important;
        text-align: justify !important;
        line-height: 1.1 !important;
        max-width: 100% !important;
        margin: 0 auto !important;
        padding: 0 5px !important;
      }
      .terms__content h3 {
        font-weight: 600 !important;
        margin: 3px 0 !important;
        font-size: 10px !important;
      }
      img {
        max-width: 100% !important;
      }
      .customer-details {
        margin-bottom: 5px !important;
      }
      .customer-details-header {
        background-color: #12406a !important;
        color: white !important;
        padding: 2px 5px !important;
        font-weight: bold !important;
        margin-bottom: 2px !important;
        font-size: 9px !important;
      }
      .customer-details-content {
        padding: 3px 5px !important;
      }
      .logo-section img {
        max-width: 150px !important;
        height: auto !important;
        position: absolute !important;
        top: 0 !important;
        right: 0 !important;
      }
      .kind-attention {
        text-align: right !important;
      }
      .date-quotation {
        text-align: right !important;
      }`;
    clone.appendChild(style);
    
  };

  const fetchData = async (id) => {
    try {
      const response = await dispatch(
        fetchInquiryQuotationById(id),
      ).unwrap();
      setQuotationData(response?.data);
    } catch (error) {
      console.error('Failed to fetch quotation:', error);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Section Number',
      dataIndex: 'section_no',
      key: 'section_no',
    },
    {
      title: 'Length(mm)',
      dataIndex: 'length',
      key: 'length',
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy_detail',
      key: 'alloy_detail',
      render: (_, record) => {
        const alloyName = record?.alloy_detail?.name || 'N/A';
        const alloyCode = record?.alloy_detail?.color_code || 'N/A';
        return (
          <span>
            {alloyName} ({alloyCode})
          </span>
        );
      }
    },
     {
      title: 'Temper',
      dataIndex: 'temper_detail',
      key: 'temper_detail',
      align: 'center',
      render: (_, record) => {
        const temperName = record?.temper_detail?.name || 'N/A';
        const temperCode = record?.temper_detail?.code || 'N/A';

        return (
          <span>
            {temperName} ({temperCode})
          </span>
        );
      },
    },
     {
      title: 'Price/Kg(Rs.)',
      dataIndex: 'price_per_kg',
      render: price_per_kg => {
        return <span>{!isNaN(price_per_kg) ? Number(price_per_kg).toFixed(2) : 'N/A'}</span>;
      },
    },
     {
      title: 'Price/Kg(Rs.)',
      dataIndex: 'quantity',
      render: quantity => {
        return <span>{!isNaN(quantity) ? Number(quantity) : 'N/A'}</span>;
      },
    },
    {
      title: 'Surface Finish',
      dataIndex: 'surface_finish_detail',
      key: 'surface_finish_detail',
      width: 90,
      align: 'center',
      render: (surface_finish_detail) => {
        if (surface_finish_detail && surface_finish_detail.length > 0) {
          return surface_finish_detail.map(item => item.name).join(', ');
        }
        return 'N/A';
      },
    },
   
  ];
  

  return (
    <>
      {loadingPDF && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 48, color: '#12406a' }} spin />}
            tip="Generating PDF..."
          />
        </div>
      )}
      <div>
        <div className="sticyaction">
          <Row className="pagenamerow mb-0" justify="space-between" align="middle">
            <Col>
              <h2 style={{ margin: 0 }}>View Inquiry Quotation</h2>
              <div className="bredcrumbwrp">
                <Link to="/inquiry-quotation-list" className="back">
                  <Back /> BACK
                </Link>

                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to="/inquiry-quotation-list">Quotations</Link> },
                    { title: 'View Inquiry Quotation' },
                  ]}
                />
              </div>
            </Col>

            <Col>
              {currentUser.permissions.permissions.inquiry_quotation.includes(
                'change_inquiryquotation',
              ) && (
                  <Button
                    type="primary"
                    style={{
                      marginBottom: '20px',

                      marginRight: '10px',
                    }}
                    icon={<EditOutlined />}
                    onClick={() => navigate(`/edit-inquiry-quotation/${quotationData?.id}`)}
                  >
                    Edit Quotation
                  </Button>
                )}
             {quotationData?.status !== 'SalesOrder' && currentUser.permissions.permissions.inquiry_quotation.includes(
                'change_inquiryquotation',
              ) && (
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  style={{
                    marginBottom: '20px',
                    float: 'center',
                    marginRight: '10px',
                  }}
                  onClick={() =>
                    navigate(`/create-sales-order-inquiry-quotation/${quotationData?.id}`)
                  }
                >
                  Convert To Sales Order
                </Button>
              )}
              {/* {currentUser.permissions.permissions.inquiry_quotation.includes(
                'print_inquiry_quotation_pdf_copy',
              ) && (
                  <Tooltip placement="top" title={'Download PDF'}>
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      style={{ marginBottom: '20px', float: 'right' }}
                      onClick={handleDownloadPDF}
                    >
                      Download PDF
                    </Button>
                  </Tooltip>
                )} */}
              <div style={{ display: 'none' }}>
                <div ref={printRef} style={{ width: '700px' }}>
                 
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className='formwrapper'>
          <Row gutter={[16, 16]} className="viewform">
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Quotation Number</label>
              {quotationData?.quotation_no || 'N/A'}
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Quotation Date</label>
              <div className="customvalue">
                {quotationData
                  ? dayjs(quotationData.quotation_date).format('DD-MM-YYYY')
                  : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Customer Name</label>
              <div className="customvalue">
                {quotationData?.customer_name}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Inquiry No.</label>
              <div className="customvalue">
                {quotationData?.inquiry_number || 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Converted Date</label>
              <div className="customvalue">
                {quotationData?.converted_date
                  ? dayjs(quotationData.converted_date).format('DD-MM-YYYY')
                  : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Status</label>
              <div className="customvalue">{quotationData?.status || 'N/A'}</div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Remarks</label>
              <div className="customvalue">{quotationData?.remarks || 'N/A'}</div>
            </Col>

          </Row>

          <Divider />

          <div className="flex justify-between gridtitle">
            <h3>Quotation Items List</h3>
          </div>

          <Table className='px-0'
            rowKey="id"
            dataSource={quotationData?.inquiry_quotation_details}
            columns={columns}
            pagination={false}
            scroll={{
              x: 1500,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ViewInquiryQuotation;
